import React, { useEffect } from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import lozad from 'lozad';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const VideoComponent: MyComponentType<Props> = (props: Props) => {
  const { id, privateSchema, parentNodeIsBody } = props;

  useEffect(() => {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  }, []);

  return (
    <div
      style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {}, {
        width: '100%',
        display: 'block',
      })}
    >
      <video id={id} autoPlay={privateSchema?.autoPlay} controls muted loop className="lozad">
        <source data-src={privateSchema?.src?.[0]?.mediaSrc || props.config.src} type="video/mp4" />
      </video>
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/VideoComponentDefinition'));

VideoComponent.definition = {
  id: ComponentIdEnum.VIDEO_COMPONENT,
  name: '视频组件_1',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/VSfJsibbRNVvlhii0rYxb.png?image_process=resize,w_200',
  position: 10, // 显示顺序
  config: {
    text: '这是一个视频容器',
    src: 'https://cdn.resource.youniverse.cc/d2c-app-dev/_bCPSLoJP1DG-PEzzo8jl.mp4',
  },
  privateSchema: {
    autoPlay: true,
  },
  category: 'media',
  configForm: ConfigHOC(ConfigForm),
};
